import React, { useState } from 'react';

import { PAX_DETAILS, TRAVEL_CLASS_TEXT, DONE_TEXT } from '@stencil/flights-constants/src/text';

import * as S from './pax-widget.styles';
import DropDown from '../DropDown/drop-down';

const PaxWidget = React.forwardRef(
  (
    props: {
      togglePaxWidget;
      gaHandler;
      passengers;
      flightClass;
      flightClassList;
      paxDoneHandler;
      classDoneHandler;
      language;
      kidsNotAllowed;
    },
    ref
  ) => {
    const {
      togglePaxWidget,
      gaHandler,
      passengers,
      flightClass,
      flightClassList,
      paxDoneHandler,
      classDoneHandler,
      language,
      kidsNotAllowed
    } = props;

    const [error, setError] = useState('');
    const [adultCount, setAdultCount] = useState(passengers.adult);
    const [childCount, setChildCount] = useState(passengers.child);
    const [infantCount, setInfantCount] = useState(passengers.infant);
    const totalCount = adultCount + childCount + infantCount;

    const [flightClassState, setFlightClassState] = useState(flightClass);

    const handleFlightClassSelection = newValue => {
      for (let i = 0; i < flightClassList.length; i++) {
        const { value } = flightClassList[i];
        if (newValue === value) {
          setFlightClassState(flightClassList[i]);
        }
      }
    };

    const doneClickHandler = () => {
      paxDoneHandler({
        adult: adultCount,
        child: childCount,
        infant: infantCount
      });
      classDoneHandler(flightClassState);
      togglePaxWidget(false);
    };

    const adultDecClicker = () => {
      if (adultCount === 1) {
        return;
      }
      setAdultCount(adultCount - 1);
    };

    const adultIncClicker = () => {
      if (totalCount === 9) {
        handlePaxError('Maximum of 9 travellers are allowed');
        return;
      }
      if (adultCount === 9) {
        return;
      }
      setAdultCount(adultCount + 1);
    };

    const childDecClicker = () => {
      if (childCount === 0) {
        return;
      }
      setChildCount(childCount - 1);
    };

    const childIncClicker = () => {
      if (totalCount === 9) {
        handlePaxError('Maximum of 9 travellers are allowed');
        return;
      }
      if (childCount === 9) {
        return;
      }
      setChildCount(childCount + 1);
    };

    const infantDecClicker = () => {
      if (infantCount === 0) {
        return;
      }
      setInfantCount(infantCount - 1);
    };

    const infantIncClicker = () => {
      if (totalCount === 9) {
        handlePaxError('Maximum of 9 travellers are allowed');
        return;
      }
      if (infantCount === adultCount) {
        handlePaxError('Number of infants cannot be more than adults');
        return;
      }
      setInfantCount(infantCount + 1);
    };

    const handlePaxError = err => {
      setError(err);
      setTimeout(() => {
        setError('');
      }, 5000);
    };
    const { adult, child, infant } = PAX_DETAILS[language];

    return (
      <S.WrapperDiv ref={ref}>
        <S.ContentWrapperDiv>
          <S.ContentItemWrapperDiv>
            <S.ContentItemTextWrapperSpan>
              {adult.name}
              <S.ContentItemConditionTextWrapperSpan>
                {adult.value}
              </S.ContentItemConditionTextWrapperSpan>
            </S.ContentItemTextWrapperSpan>
            <S.ContentActionWrapperDiv>
              <S.ContentActionIconWrapperSpan onClick={adultDecClicker}>
                -
              </S.ContentActionIconWrapperSpan>
              <S.ContentActionValueWrapperSpan>{adultCount}</S.ContentActionValueWrapperSpan>
              <S.ContentActionIconWrapperSpan onClick={adultIncClicker}>
                +
              </S.ContentActionIconWrapperSpan>
            </S.ContentActionWrapperDiv>
          </S.ContentItemWrapperDiv>
          <S.ContentItemWrapperDiv>
            <S.ContentItemTextWrapperSpan>
              {child.name}
              <S.ContentItemConditionTextWrapperSpan>
                {child.value}
              </S.ContentItemConditionTextWrapperSpan>
            </S.ContentItemTextWrapperSpan>
            <S.ContentActionWrapperDiv disabled={kidsNotAllowed}>
              <S.ContentActionIconWrapperSpan onClick={childDecClicker} disabled={kidsNotAllowed}>
                -
              </S.ContentActionIconWrapperSpan>
              <S.ContentActionValueWrapperSpan>{childCount}</S.ContentActionValueWrapperSpan>
              <S.ContentActionIconWrapperSpan onClick={childIncClicker} disabled={kidsNotAllowed}>
                +
              </S.ContentActionIconWrapperSpan>
            </S.ContentActionWrapperDiv>
          </S.ContentItemWrapperDiv>
          <S.ContentItemWrapperDiv>
            <S.ContentItemTextWrapperSpan>
              {infant.name}
              <S.ContentItemConditionTextWrapperSpan>
                {infant.value}
              </S.ContentItemConditionTextWrapperSpan>
            </S.ContentItemTextWrapperSpan>
            <S.ContentActionWrapperDiv disabled={kidsNotAllowed}>
              <S.ContentActionIconWrapperSpan onClick={infantDecClicker} disabled={kidsNotAllowed}>
                -
              </S.ContentActionIconWrapperSpan>
              <S.ContentActionValueWrapperSpan>{infantCount}</S.ContentActionValueWrapperSpan>

              <S.ContentActionIconWrapperSpan onClick={infantIncClicker} disabled={kidsNotAllowed}>
                +
              </S.ContentActionIconWrapperSpan>
            </S.ContentActionWrapperDiv>
          </S.ContentItemWrapperDiv>
          {error ? <S.Error>Error: {error}</S.Error> : null}
          <S.ButtonWrapperDiv>
            <S.FlightClassWrapper>
              <S.FlightClassLabel>{TRAVEL_CLASS_TEXT[language]}</S.FlightClassLabel>
              <DropDown
                handleSelection={handleFlightClassSelection}
                value={flightClassState}
                list={flightClassList}
              />
            </S.FlightClassWrapper>
            <S.ButtonWrapper onClick={doneClickHandler}>{DONE_TEXT[language]}</S.ButtonWrapper>
          </S.ButtonWrapperDiv>
        </S.ContentWrapperDiv>
      </S.WrapperDiv>
    );
  }
);

export default PaxWidget;
